<div class="container">
    <div *ngFor="let resource of selectedResources; let i = index" class="indicators_container">
        <button (click)="removeResource(i, resource.id)"  class="exclude_indicator">X</button>

        <div class="indicator_box">
            <h6>Indicador</h6>
            <select 
                [(ngModel)]="resource.name" 
                (ngModelChange)="updateResource()"
            >
                <option *ngFor="let indicator of indicatorsTranslated" [value]="indicator.value">{{indicator.name}}</option>
            </select>
        </div>
        
        <div class="indicator_box">
            <h6>Quantidade</h6>
            <input 
                [(ngModel)]="resource.quantity" 
                type="number"
                (blur)="updateResource()"
            >
        </div>

        <div class="indicator_box">
            <h6>Unidade</h6>
            <select 
                [(ngModel)]="resource.unity" 
                (ngModelChange)="updateResource()"
            >
                <option  *ngFor="let unity of unities" [value]="unity">{{unity}}</option>
            </select>
        </div>

        <div class="indicator_box">
            <h6>Pontuação</h6>
            <input disabled [value]="resource.pontuation.toFixed(2).replace('.', ',')" />
        </div>
    </div>

    <button *ngIf="showAddIndicatorBtn" (click)="addResource()" class="plus">+</button>
</div>